import { Col, Row } from '@advanza/grid'
import { Divider, MaxWidth } from '@advanza/ui'
import Page from 'components/ui/Page'
import React from 'react'

interface ReportPageTemplateProps {
    title: string
    description: string
    exportButton: React.ReactNode
    filterComponent: React.ReactNode
    listComponent: React.ReactNode
    analyticsComponent?: React.ReactNode
}

const ReportPageTemplate = ({
    title,
    description,
    exportButton,
    filterComponent,
    listComponent,
    analyticsComponent,
}: ReportPageTemplateProps) => {
    return (
        <Page title={title}>
            <MaxWidth maxWidth={1600}>
                <Divider m />
                <Row middle="xs" between="xs">
                    <Col x>
                        <h1>{title}</h1>
                        <p className="text-grey-700 mt-2">{description}</p>
                    </Col>
                    <Col x>{exportButton}</Col>
                </Row>
                <Divider />
                {filterComponent}
                {analyticsComponent && (
                    <>
                        <Divider />
                        {analyticsComponent}
                    </>
                )}
                <Divider />
                {listComponent}
            </MaxWidth>
        </Page>
    )
}

export default ReportPageTemplate
